import alerts from '@/mixins/alerts'
import store from '@/store'
import Vue from 'vue'
import i18n from '@/libs/i18n'
import isElectron from 'is-electron'

const environment = window.env || 'local'
const isProduction = environment === 'production'

const blockInactivePdvAccess = (to, from, next) => {
  
  if (!isElectron()) {
    // No browser, o PDV só é bloqueado em produção. Em local/dev/staging
    // liberamos o acesso para permitir testes das telas de PDV/ATM.
    if (isProduction) {
      return next({ name: 'home', replace: true })
    }
    return next()
  }

  if (!store.getters['pages/pdv/payBoxConfiguration/isPdvInactive']) {
    return next()
  }

  alerts.methods.showWarning.call(
    {
      $toast: Vue.prototype.$toast,
      $t: i18n.t.bind(i18n),
    },
    {
      message: i18n.t('PAYBOX.INACTIVE'),
    }
  )

  store.dispatch('app/hideAllLoadingOverlays')

  return next({ name: 'home', replace: true })
}

export default blockInactivePdvAccess
